import { RouteName, RoutePath, ScreenName } from '@helpcenter/constants';
import type { PaperAppearance } from 'view/layout/paper';
import { CsmFolder } from '@atlassian/csm-folder';
import { CsmEmptyFolderResource } from '@atlassian/csm-folder/src/services/csm-empty-folder-resource';
import { CsmFolderResource } from '@atlassian/csm-folder/src/services/csm-folder-resource';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';

const folder = {
    resources: [CsmFolderResource, CsmEmptyFolderResource],
    name: RouteName.CSM_FOLDER_PAGE,
    path: RoutePath.CSM_FOLDER_PATH,
    exact: true,
    component: CsmFolder,
};

const layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide' as PaperAppearance,
    fadeInSearchModal: true,
    prefetchBrandingModel: true,
};

export const csmFolderRoute = createRouteWithLayout(folder, ScreenName.CSM_FOLDER, layoutProps);
